<script>
  import { onMount } from "svelte"
  import ProductRow from "../components/ProductShowWizard/ProductRow.svelte"
  import OptionButton from "../components/ProductShowWizard/OptionButton.svelte"
  import ServiceOption from "../components/ProductShowWizard/ServiceOption.svelte"
  import RelatedProduct from "../components/ProductShowWizard/RelatedProduct.svelte"
  import CartSidebar from "../components/ProductShowWizard/CartSidebar.svelte"
  import CartForm from "../components/ProductShowWizard/CartForm.svelte"
  import StyledCheckbox from "../components/ProductShowWizard/StyledCheckbox.svelte"
  import AdditionalPendant from "../components/ProductShowWizard/AdditionalPendant.svelte"

  export let taxon
  export let products
  export let step
  export let relatedProducts
  export let onSale = false

  $: selectedRelatedProducts = relatedProducts.filter(
    (product) => product.qty > 0,
  )
  export let additionalPendants
  $: selectedAdditionalPendants = additionalPendants.filter(
    (product) => product.qty > 0,
  )

  export let authToken
  let selectedProduct = products[0]
  $: selectedDuration = selectedProduct.price_duration
  function durationAbbr(duration) {
    if (duration) {
      switch (duration.toLowerCase()) {
        case "monthly":
          return "mo"
        case "quarterly":
          return "qtr"
        case "annual":
          return "yr"
      }
    } else {
      return ""
    }
  }

  let selectedHelpButton
  let selectedSecondHelpButton
  let selectedFallDetection
  let selectedProtectionPlan
  let selectedDailyCheckIn
  let selectedCaregiverApp
  let selectedMedicationReminders
  let selectedLocationService
  let selectedActivityAssurance
  let hasLandline = false
  let landlineProvider
  let selectedWristbandType

  $: selectedProductIsChanged(selectedProduct)
  function selectedProductIsChanged() {
    selectedHelpButton = null
    selectedSecondHelpButton = null
    selectedFallDetection = null
    selectedProtectionPlan = null
    selectedDailyCheckIn = null
    selectedCaregiverApp = null
    selectedMedicationReminders = null
    selectedLocationService = null
    selectedActivityAssurance = null
    hasLandline = false
    landlineProvider = null
    selectedWristbandType = null
  }

  function optionTotal(option) {
    return option && option.surcharge ? parseFloat(option.surcharge) : 0
  }

  $: cartTotal =
    parseFloat(selectedProduct.price) +
    optionTotal(selectedHelpButton) +
    optionTotal(selectedFallDetection) +
    optionTotal(selectedProtectionPlan) +
    optionTotal(selectedDailyCheckIn) +
    optionTotal(selectedCaregiverApp) +
    optionTotal(selectedMedicationReminders) +
    optionTotal(selectedLocationService) +
    optionTotal(selectedActivityAssurance) +
    optionTotal(selectedWristbandType)

  const durationFactors = {
    monthly: 1,
    quarterly: 3,
    annual: 12,
  }

  function monthlyPrice(total, duration) {
    if (total && duration && durationFactors[duration.toLowerCase()]) {
      const factor = durationFactors[duration.toLowerCase()]
      return (parseFloat(total) / factor).toFixed(2)
    } else {
      return parseFloat(total).toFixed(2)
    }
  }

  function validateRequiredFields(currentStep) {
    const section = document.querySelector(`.step-${currentStep}`)
    const requiredFields = section.querySelectorAll("[validateRequired]")
    let valid = true

    requiredFields.forEach((field) => {
      const isValid = validateField(field)
      if (isValid) {
        field.querySelector(".invalid-error").classList.remove("show")
      } else {
        field.querySelector(".invalid-error").classList.add("show")
        window.scrollTo({ top: field.offsetTop, behavior: "smooth" })
        valid = false
        console.warn("Required fields are missing")
      }
    })

    return valid
  }

  function findOption(name) {
    return products.some((product) => {
      return product.option_types.some((option) => {
        return option.category === name
      })
    })
  }
  const helpButtonOptionExists = findOption("Help Button Style")
  const fallDetectionOptionExists = findOption("Fall Detection")
  const secondHelpButtonOptionExists = findOption("Second Help Button Style")
  const wristbandTypeExists = findOption("Wristband Type")

  function getOptionPresentation(category) {
    const option_type = products[0].option_types.find(
      (ot) => ot.category === category,
    )
    return option_type.presentation
  }

  let showSecondHelpButtonOption = false

  $: {
    const optionSelected =
      selectedHelpButton?.name === "Necklace w/ Fall Detection"
    showSecondHelpButtonOption = secondHelpButtonOptionExists && optionSelected
    if (!optionSelected) {
      selectedSecondHelpButton = null
    }
  }

  function validateField(field) {
    const select = field.querySelector("[selected=true]")
    const checkbox = field.querySelector("input[type=checkbox]:checked")
    return select || checkbox
  }

  function decrementStep() {
    if (step.current > 0) {
      step.current--
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
    updateWizardHeader()
  }

  function incrementStep() {
    if (validateRequiredFields(step.current)) {
      if (step.current < step.total) {
        step.current++
        window.scrollTo({ top: 0, behavior: "smooth" })
      } else {
        addToCart()
      }
    }
    updateWizardHeader()
  }

  async function addToCart() {
    for (const relatedProduct of [
      ...selectedAdditionalPendants,
      ...selectedRelatedProducts,
    ]) {
      const data = {
        authenticity_token: authToken,
        variant_id: relatedProduct.variant.id,
        quantity: relatedProduct.qty,
      }
      const formData = new FormData()
      for (const name in data) {
        formData.append(name, data[name])
      }
      await fetch("/cart_line_items", {
        method: "POST",
        body: formData,
      }).then(function () {
        console.log(`Added ${relatedProduct.name}`)
      })
    }
    await new Promise((resolve) => setTimeout(resolve, 500)) // wait for any remaining promise to complete
    document.querySelector("#cartForm").submit()
  }

  function expandAccordion(e) {
    const content =
      e.currentTarget.parentNode.querySelector(".accordion-content")
    content.classList.toggle("expanded")
  }

  export let sectionTitle = ""

  let scrollY

  function updateWizardHeader() {
    const productServices = document.querySelector("section.product-services")
    const productServicesY = productServices
      ? productServices.offsetTop + productServices.offsetHeight
      : 0

    const additionalPendants = document.querySelector(
      "section.additional-pendants",
    )
    const additionalPendantsY = additionalPendants
      ? additionalPendants.offsetTop + additionalPendants.offsetHeight
      : 0

    const additionalProducts = document.querySelector(
      "section.additional-products",
    )
    const additionalProductsY = additionalProducts
      ? additionalProducts.offsetTop + additionalProducts.offsetHeight
      : 0

    if (productServicesY > 0 && scrollY <= productServicesY) {
      const title = productServices.querySelector(".title")
      sectionTitle = " - " + title.textContent
    } else if (additionalPendantsY > 0 && scrollY <= additionalPendantsY) {
      const title = additionalPendants.querySelector(".title")
      sectionTitle = " - " + title.textContent
    } else if (additionalProductsY > 0 && scrollY <= additionalProductsY) {
      const title = additionalProducts.querySelector(".title")
      sectionTitle = " - " + title.textContent
    } else {
      sectionTitle = ""
    }
  }

  let taxonNamePlain = (taxon.name || "").replace(/<\/?sup>/g, "")

  const disclaimerBattery1Year = `
    <span class='disclaimer-asterisk-footer'>*</span>When fall detection is added to your account, battery life is approximately 1 year. <br>
    Since no fall detection system detects 100% of falls, if able, subscribers
    should press their help button in any emergency.
  `

  const disclaimerBattery1YearLandline = `
    <span class='disclaimer-asterisk-footer'>*</span>When fall detection is added to your account, battery life is approximately 1 year. <br>
    <span class='disclaimer-asterisk-footer'>**</span>We make no guarantees that the landline system is compatible with all landline phone services and VOIP phones.<br>
    Since no fall detection system detects 100% of falls, if able, subscribers
    should press their help button in any emergency.
  `

  const disclaimerBatteryReduced = `
    <span class='disclaimer-asterisk-footer'>*</span>When fall detection is added to your account, battery life may be reduced. <br>
    Since no fall detection system detects 100% of falls, if able, subscribers
    should press their help button in any emergency.
  `

  const disclaimerVipFlex = `
    Your VIP flex system will include accessories for all configurations, wristband,
    necklace and belt clip, to wear as you wish. When ordering, please indicate your 
    preference for either a standard wristband or Velcro wristband.<br>
    <span class='disclaimer-asterisk-footer'>*</span>When fall detection is added to your account, battery life may be reduced.<br>
    Since no fall detection system detects 100% of falls, if able,
    subscribers should press their help button in any emergency.
  `

  const taxonMappings = {
    Landline: disclaimerBattery1YearLandline,
    Cellular: disclaimerBattery1Year,
    VIPx: disclaimerBatteryReduced,
    VIPx2: disclaimerBatteryReduced,
    "VIP Active": disclaimerBatteryReduced,
    "Safe Watch Active": disclaimerBatteryReduced,
    "VIP flex": disclaimerVipFlex,
  }

  const precomputedTaxonMap = Object.fromEntries(
    Object.entries(taxonMappings).map(([key, value]) => [key.trim().toLowerCase(), value])
  );

  function getTaxonDisclaimer(taxonName) {
    const lowerCaseTaxonName = taxonName.trim().toLowerCase();
    for (const [key, value] of Object.entries(precomputedTaxonMap)) {
      if (lowerCaseTaxonName.includes(key)) {
        return value;
      }
    }
    return null;
  }

  onMount(async () => {
    // Sticky bottom panel styles
    const panelControls = document.querySelector(".panel-controls")
    if (panelControls) {
      const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("stuck", e.intersectionRatio < 1),
        { threshold: [1] },
      )
      observer.observe(panelControls)
    }
    const accordions = document.querySelectorAll(".expandable-accordion")
    Array.from(accordions).forEach((accordion) => {
      accordion.addEventListener("click", (e) => expandAccordion(e))
    })
  })
</script>

<svelte:window bind:scrollY on:scroll={updateWizardHeader} />

<div
  class="relative mb-12 md:pt-11 product-show-wizard"
  data-step={step.current}
  id="productShowWizard"
>
  <div
    class="container flex flex-col md:items-end md:gap-4 md:flex-row items-center md:justify-between border-b border-b-gray-medium mb-5 pb-1 sticky top-[43px] md:pt-4 md:pb-2 bg-white z-10"
  >
    <div class="product-name">
      <h1 class="text-base leading-8 md:text-3xl text-sky-primary">
        {@html taxon.name}<span id="wizardSectionTitle">{sectionTitle}</span>
      </h1>
    </div>
    <div class="text-sm sm:text-base text-sky-primary whitespace-nowrap totals">
      <span class="mr-2">Subtotal </span>
      <span class="mr-5 font-semibold text-red-secondary sm:text-xl"
        >${parseFloat(cartTotal).toFixed(2)} /{durationAbbr(
          selectedDuration,
        )}</span
      > <span>${monthlyPrice(cartTotal, selectedDuration)} /mo</span>
    </div>
  </div>
  <div class="container panels relative">
    <div class="panel step-1" data-current-step={step.current == 1}>
      <div
        class="product-essential pb-8 mb-8 border-b border-gray-medium after:block after:clear-both after:content-['']"
      >
        <div
          class="media md:hidden lg:block w-full float-none lg:w-[30%] mb-4 lg:mb-5 lg:float-left"
        >
          <div class="product-image">
            {#if onSale}
              <span class="sale hidden lg:flex">Sale</span>
            {/if}
            <a
              href={taxon.image}
              title={taxonNamePlain}
              class="block max-w-[400px] mx-auto"
            >
              {#if taxon.image}
                <img
                  src={taxon.image}
                  alt={taxonNamePlain}
                  width={taxon.image.width}
                  height={taxon.image.height}
                  class="lg:px-6"
                />
              {/if}
            </a>
          </div>
        </div>
        <div
          class="payment-plan md:float-left md:w-3/5 lg:w-2/5 text-sky-primary"
        >
          <h2 class="mb-5 text-center md:text-left">Choose Payment Plan:</h2>
          <div class="options">
            <table>
              <thead>
                <tr>
                  <th />
                  <th>Plan</th>
                  <th>Cost</th>
                  <th>/ Mo</th>
                  <th>Special Offer</th>
                </tr>
              </thead>
              <tbody class="options-list">
                {#each products as product}
                  <ProductRow
                    {product}
                    durationAbbr={durationAbbr(product.price_duration)}
                    monthlyPrice={monthlyPrice(
                      product.price,
                      product.price_duration,
                    )}
                    onSale={product.on_sale}
                    originalMonthlyPrice={monthlyPrice(
                      product.original_price,
                      product.price_duration,
                    )}
                    bind:selectedProduct
                  />
                {/each}
              </tbody>
            </table>
            <div class="invalid-error">Please select a payment plan</div>
          </div>
        </div>
        <div
          class="payment-includes bg-gray-light md:float-left after:block after:content-[''] after:clear-both md:w-2/5 lg:w-[30%]"
        >
          <div class="hidden media md:block lg:hidden">
            <div class="product-image">
              <a href={taxon.image} title={taxonNamePlain}>
                {#if taxon.image}
                  <img
                    src={taxon.image}
                    alt={taxon.name}
                    width={taxon.image.width}
                    height={taxon.image.height}
                    class="px-6 pt-7"
                  />
                {/if}
              </a>
            </div>
          </div>
          <h2 class="py-4 pr-6 mb-5 text-2xl text-center text-sky-primary">
            Selected Plan Includes:
          </h2>
          <ul class="selected-plan-includes" duration={selectedDuration}>
            <li class="annual">
              <span class="wrapped"><i class="fas fa-lock" /></span> Free Lock Box
            </li>
            <li class="annual inactive">
              <span class="wrapped"><i class="fas fa-calendar-check" /></span> 12th
              Month Free
            </li>
            <li class="quarterly inactive">
              <span class="wrapped"><i class="fas fa-calendar-check" /></span> 4th
              Month Free
            </li>
            <li class="quarterly annual inactive">
              <span class="wrapped"><i class="fas fa-shipping-fast" /></span> Free
              Ground Shipping
            </li>
            <li class="monthly quarterly annual">
              <span class="wrapped"><i class="fa-solid fa-box-open" /></span> Free
              Activation
            </li>
            <li class="monthly quarterly annual">
              <span class="wrapped"><i class="fa-solid fa-clock" /></span> 24/7 Emergency
              Care Monitoring
            </li>
            <li class="monthly quarterly annual">
              <span class="wrapped"><i class="fa-solid fa-user" /></span> Personalized
              Emergency Response Plan
            </li>
            <li class="monthly quarterly annual">
              <span class="wrapped"><i class="fa-solid fa-money-bill" /></span> Price
              Lock Guarantee
            </li>
          </ul>
          <h3
            class="pb-4 pr-4 mt-5 text-lg font-semibold text-sky-secondary pl-9"
          >
            30-day Money Back Guarantee
          </h3>
        </div>
      </div>
      <div class="product-extras">
        <div class="md:grid md:grid-cols-2 md:gap-8">
          {#if helpButtonOptionExists}
            <div>
              <div class="help-button optionalbe" validateRequired>
                <h2>
                  Select {getOptionPresentation("Help Button Style")}
                </h2>
                <div class="invalid-error">Please select an option</div>
                <ul class="options">
                  {#each products as product}
                    {@const opt = product.option_types.find(
                      (ot) => ot.category === "Help Button Style",
                    )}
                    {#if opt}
                      {#each opt.option_values as value}
                        <OptionButton
                          {product}
                          {value}
                          {selectedProduct}
                          bind:selectedOption={selectedHelpButton}
                        />
                      {/each}
                    {/if}
                  {/each}
                </ul>
              </div>
            </div>
          {/if}
          {#if showSecondHelpButtonOption}
            <div>
              <div class="help-button optionalbe">
                <h2>
                  Select {getOptionPresentation("Second Help Button Style")}
                </h2>
                <div class="invalid-error">Please select an option</div>
                <ul class="options">
                  {#each products as product}
                    {@const opt = product.option_types.find(
                      (ot) => ot.category === "Second Help Button Style",
                    )}
                    {#if opt}
                      {#each opt.option_values as value}
                        <OptionButton
                          {product}
                          {value}
                          {selectedProduct}
                          bind:selectedOption={selectedSecondHelpButton}
                        />
                      {/each}
                    {/if}
                  {/each}
                </ul>
              </div>
            </div>
          {/if}
          {#if taxon["requires-landline"]}
            <div>
              <div class="have-landline optionalbe" validateRequired>
                <h2>Do you have a Landline?</h2>
                <ul class="options mb-7">
                  <li>
                    <div class="invalid-error">
                      Please check that you have a landline system
                    </div>
                    <StyledCheckbox
                      bind:value={hasLandline}
                      label="YES I have a landline system"
                    />
                  </li>
                </ul>
                <h2>Who is your landline<span class='disclaimer-asterisk'>**</span> provider? (if known)</h2>
                <div class="input-wrapper">
                  <input
                    class="border border-sky-primary w-80 align-middle text-gray-dark p-2 text-xs"
                    type="text"
                    bind:value={landlineProvider}
                  />
                </div>
              </div>
            </div>
          {/if}
          {#if wristbandTypeExists}
            <div>
              <div class="help-button optionalbe" validateRequired>
                <h2>
                  Select {getOptionPresentation("Wristband Type")}
                </h2>
                <div class="invalid-error">Please select an option</div>
                <ul class="options">
                  {#each products as product}
                    {@const opt = product.option_types.find(
                      (ot) => ot.category === "Wristband Type",
                    )}
                    {#if opt}
                      {#each opt.option_values as value}
                        <OptionButton
                          {product}
                          {value}
                          {selectedProduct}
                          bind:selectedOption={selectedWristbandType}
                        />
                      {/each}
                    {/if}
                  {/each}
                </ul>
              </div>
            </div>
          {/if}
          {#if fallDetectionOptionExists}
            <div>
              <div class="fall-detection optionalbe">
                <h2>Add {getOptionPresentation("Fall Detection")}</h2>
                <div class="invalid-error">Please select an option</div>
                <ul class="options">
                  {#each products as product}
                    {@const opt = product.option_types.find(
                      (ot) => ot.category === "Fall Detection",
                    )}
                    {#if opt}
                      {#each opt.option_values as value}
                        <OptionButton
                          {product}
                          {value}
                          {selectedProduct}
                          bind:selectedOption={selectedFallDetection}
                        />
                      {/each}
                    {/if}
                  {/each}
                </ul>
              </div>
            </div>
          {/if}
        </div>
        <p class="disclaimer">
          {@html getTaxonDisclaimer(taxon.name) || ""}
        </p>
      </div>
    </div>
    <div class="panel step-2" data-current-step={step.current == 2}>
      <section class="container product-services">
        <div class="hidden title">Service Options</div>
        <div class="flex flex-wrap">
          <ServiceOption
            {products}
            {selectedProduct}
            bind:selectedOption={selectedCaregiverApp}
            className="caregiver-app"
            title="Caregiver App"
            description="<p>The Caregiver Mobile App works
              in tandem with the VIPx2 to offer increased
              peace of mind for subscribers and their loved
              ones. The VIPx2 Caregiver Mobile App enhances
              the experience with the VIPx2 device by offering
              helpful information at a glance for caregivers.</p>"
            checkmarkList={[
              "View the Current Location",
              "Check First Motion of the Day",
              "Manually Ring the Device",
              "View Button Press History",
              "Step Tracking & History",
              "In App Alerts and much more",
            ]}
          />
          <ServiceOption
            {products}
            {selectedProduct}
            bind:selectedOption={selectedProtectionPlan}
            className="protection-plan"
            title="LifeFone Protection Plan"
            description={`<div class="expandable-accordion">
              <div class="item">
                <p
                  class="accordion-title"
                >
                  The Protection Plan assures you will have quick
                  replacement of your medical alert equipment, after a <u
                    >replacement deductible.</u
                  >
                </p>
                <p class="accordion-content">
                  $6 for Standard Pendant.<br />
                  $29 for Base Station or Voice in Pendant.
                </p>
              </div>
            </div>`}
            checkmarkList={[
              "Lost or theft of button",
              "Damage from normal wear and tear",
              "Damage due to heat and humidity",
              "Drops, spills or accidents",
              "Power surges and battery replacements",
            ]}
          />
          <ServiceOption
            {products}
            {selectedProduct}
            bind:selectedOption={selectedDailyCheckIn}
            className="daily-check-in"
            title="Daily Check-In"
            description="<p>With the daily reminder service,
              LifeFone care agents will make a daily outbound
              call to the subscriber.</p>"
            checkmarkList={[
              "Daily reminder service",
              "Customize the calls to fit your needs",
              "All LifeFone subscribers are eligible",
              "Preselect time of day you would like calls",
            ]}
          />
          <ServiceOption
            {products}
            {selectedProduct}
            bind:selectedOption={selectedMedicationReminders}
            title="Medication Reminders"
            className="medication-reminders"
            description="<p>LifeFone&rsquo;s medication
              reminders will tell a subscriber when and
              what medication(s) he or she needs to
              take on a daily or weekly basis.</p>"
            checkmarkList={[
              "These reminders can be updated as needed",
              "Medication reminders on a daily or weekly basis",
            ]}
          />
          <ServiceOption
            {products}
            {selectedProduct}
            bind:selectedOption={selectedLocationService}
            className="location-services"
            title="Location Service"
            description="<p>
              LifeFone&rsquo;s Location Service enables a
              caregiver authorized by the LifeFone subscriber
              to know the location of the subscriber&rsquo;s
              LifeFone mobile device if the subscriber uses one
              of LifeFone&rsquo;s two on-the-go systems. This is
              a feature that can be hugely helpful if and when
              you need to locate a loved one whom you can&rsquo;t
              reach otherwise.</p>"
            checkmarkList={[]}
          />
          <ServiceOption
            {products}
            {selectedProduct}
            bind:selectedOption={selectedActivityAssurance}
            className="activity-assurance"
            title="Activity Assurance"
            description="<p>
            LifeFone&rsquo;s Activity Assurance Service
            enables subscribers to check-in with an
            emergency care agent in our call center each day.
            </p>
            <p>By pressing a button on their base unit, it
              lets us know whether or not the subscriber is
              at home and responding to the reminder.
            </p>"
            checkmarkList={[]}
          />
        </div>
      </section>
      {#if additionalPendants.length > 0}
        <section class="container product-crosssells additional-pendants">
          <div class="mt-6 mb-12 md:border-b md:border-gray-medium">
            <div class="title">Additional Pendants</div>
          </div>
          <div
            class="text-red-secondary md:text-2xl min-h-[74px] text-base text-center md:text-left"
          >
            Additional Help Buttons
          </div>
          <div class="flex flex-start flex-wrap">
            {#each additionalPendants as product}
              <AdditionalPendant bind:product />
            {/each}
          </div>
        </section>
      {/if}
      {#if relatedProducts.length > 0}
        <section class="container product-crosssells additional-products">
          <div class="mt-6 mb-12 md:border-b md:border-gray-medium">
            <div class="title">Add Ons</div>
          </div>
          <div class="flex flex-wrap">
            {#each relatedProducts as product}
              <RelatedProduct bind:product />
            {/each}
          </div>
        </section>
      {/if}
    </div>
  </div>
  <div class="panel-controls">
    <div class="container flex justify-center gap-4">
      {#if step.current > 1}
        <div>
          <button
            class="btn btn-primary-inverted back inverted"
            on:click={decrementStep}
            ><i class="fa-solid fa-caret-left" /> Back</button
          >
        </div>
      {/if}
      <div>
        <button class="btn btn-primary continue" on:click={incrementStep}
          >Continue <i class="fa-solid fa-caret-right" /></button
        >
      </div>
    </div>
  </div>
</div>

<CartForm
  {selectedProduct}
  {authToken}
  {selectedHelpButton}
  {selectedSecondHelpButton}
  {selectedFallDetection}
  {selectedProtectionPlan}
  {selectedDailyCheckIn}
  {selectedCaregiverApp}
  {selectedMedicationReminders}
  {selectedLocationService}
  {selectedActivityAssurance}
  {selectedWristbandType}
  {landlineProvider}
/>

<CartSidebar
  {taxon}
  {selectedDuration}
  {selectedRelatedProducts}
  {selectedAdditionalPendants}
  {selectedHelpButton}
  {selectedSecondHelpButton}
  {selectedFallDetection}
  {selectedProtectionPlan}
  {selectedDailyCheckIn}
  {selectedCaregiverApp}
  {selectedMedicationReminders}
  {selectedLocationService}
  {selectedActivityAssurance}
  {selectedWristbandType}
/>
